module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "app-content-body fade-in-up content-transition"
  }, [_c('div', {
    staticClass: "hbox hbox-auto-xs hbox-auto-sm"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "r"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                  Logs "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.pagination.totalItems))])]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "text-right text-left-xs"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "wrapper clearfix"
  }, [_c('div', {
    staticClass: "col-sm-7 m-b-xs"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-btn"
  }, [_c('a', {
    staticClass: "btn btn-sm btn-default"
  }, [_c('span', {
    staticClass: "m-r-xs font-bold"
  }), _vm._v("Períodos")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data),
      expression: "filtros.data"
    }],
    staticClass: "input-sm form-control",
    attrs: {
      "id": "filtroData"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "data", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.reloadData]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                        Qualquer data\n                      ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'Hoje'
    }
  }, [_vm._v("Hoje")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": '7dias'
    }
  }, [_vm._v("Últimos 7 dias")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'Mes'
    }
  }, [_vm._v("Este mês")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'Ano'
    }
  }, [_vm._v("Este ano")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'Periodo'
    }
  }, [_vm._v("Período")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "autocomplete-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroInput.titulo),
      expression: "filtroInput.titulo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "entitytitulo",
      "placeholder": "Placa ou número da GRV"
    },
    domProps: {
      "value": (_vm.filtroInput.titulo)
    },
    on: {
      "blur": function($event) {
        return _vm.setVisibilityOptionsAutocomplete(false)
      },
      "keyup": _vm.getListaGrvs,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtroInput, "titulo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroInput.id),
      expression: "filtroInput.id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "hidden",
      "id": "entityid"
    },
    domProps: {
      "value": (_vm.filtroInput.id)
    },
    on: {
      "blur": function($event) {
        return _vm.setVisibilityOptionsAutocomplete(false)
      },
      "keyup": _vm.getListaGrvs,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtroInput, "id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-info btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reloadData
    }
  }, [_vm._v("Buscar")])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOptionsAutocomplete),
      expression: "showOptionsAutocomplete"
    }],
    staticClass: "list-group"
  }, [(_vm.loading) ? _c('li', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })]) : (!_vm.listaGrvs.length) ? _c('li', {
    staticClass: "text-danger"
  }, [_vm._v("Grv não encontrada")]) : _vm._l((_vm.listaGrvs), function(item) {
    return _c('li', {
      key: item.id,
      on: {
        "click": function($event) {
          return _vm.setFiltroInput(item)
        }
      }
    }, [_vm._v(_vm._s(item.numero) + " - " + _vm._s(item.tipoProcesso === 1 ? item.PlacaOriginal : item.placa))])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-btn"
  }, [_c('a', {
    staticClass: "btn btn-sm btn-default"
  }, [_c('span', {
    staticClass: "m-r-xs font-bold"
  }), _vm._v("Buscar")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.busca),
      expression: "filtros.busca"
    }],
    staticClass: "input-sm form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisar"
    },
    domProps: {
      "value": (_vm.filtros.busca)
    },
    on: {
      "keyup": _vm.pesquisar,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "busca", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.filtros.data === 'Periodo') ? _c('div', {
    staticClass: "row m-l-xs m-r-xs"
  }, [_c('div', {
    staticClass: "col-md-6 filtros-periodo-datas form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data1),
      expression: "filtros.data1"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filtroData1",
      "placeholder": "dd/mm/yyyy",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.data1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "data1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "m-l m-r"
  }, [_vm._v("até")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data2),
      expression: "filtros.data2"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filtroData2",
      "placeholder": "dd/mm/yyyy",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.data2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "data2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-info m-l",
    attrs: {
      "disabled": !_vm.filtros.data1 || !_vm.filtros.data2
    },
    on: {
      "click": _vm.reloadData
    }
  }, [_vm._v("Pesquisar")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hidden-print"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFiltros),
      expression: "showFiltros"
    }],
    staticClass: "panel wrapper-lg m-t-n"
  }, [_c('div', {
    staticClass: "r-table-content_ m-t-n"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', [_vm._v("Tipo de Pessoa:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', [_vm._v("Situação:")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-striped b-t b-light"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Data")]), _vm._v(" "), _c('th', [_vm._v("Método")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', [_vm._v("Informacões GRV")]), _vm._v(" "), _c('th', [_vm._v("Resposta")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', [_vm._l(([1, 2, 3]), function(i) {
    return (_vm.isLoading) ? _c('tr', [_c('td', {
      staticClass: "v-middle"
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100px"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('a', {
      staticClass: "text-cap custom-link"
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1)]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1)]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.filteredData), function(log) {
    return _c('tr', [_c('td', {
      staticClass: "v-middle"
    }, [_vm._v(_vm._s(_vm.moment(log.date.date).format('DD/MM/YYYY HH:mm')))]), _vm._v(" "), _c('td', {
      staticClass: "v-middle",
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_vm._v("\n                    " + _vm._s(log.method) + "\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "v-middle",
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_vm._v("\n                    " + _vm._s(log.description) + "\n                  ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "white-space": "pre-wrap",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(_vm.formataInformacoesGrv(log)))]), _vm._v(" "), _c('td', {
      staticClass: "v-middle"
    }, [(log.method !== 'excluirTask') ? _c('u-button', {
      staticClass: "btn btn-info btn-xs",
      on: {
        "click": function($event) {
          return _vm.openRespostaLog(log)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" Ver resposta")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "v-middle",
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [(+log.status === 0) ? _c('span', {
      staticClass: "alert-danger",
      staticStyle: {
        "padding": "5px"
      }
    }, [_vm._v("FALHA")]) : _vm._e(), _vm._v(" "), (+log.status === 1) ? _c('span', {
      staticClass: "alert-success",
      staticStyle: {
        "padding": "5px"
      }
    }, [_vm._v("SUCESSO")]) : _vm._e()])])
  }), _vm._v(" "), (!_vm.filteredData || _vm.filteredData.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Nenhum registro encontrado")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('footer', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 hidden-xs"
  }, [_vm._v("\n                  Mostrar:\n                  "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pagination.limit),
      expression: "pagination.limit"
    }],
    staticClass: "input-sm form-control w-auto inline v-middle",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pagination, "limit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.paginationLimits), function(p) {
    return _c('option', {
      domProps: {
        "value": p
      }
    }, [_vm._v(_vm._s(p))])
  }), 0), _vm._v("\n                  por página\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-center"
  }, [_c('small', {
    staticClass: "text-muted inline m-t-sm m-b-sm"
  }, [_vm._v(_vm._s(_vm.pagination.atualPage) + " / " + _vm._s(_vm.pagination.totalPages) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right text-center-xs"
  }, [_c('u-pagination', {
    attrs: {
      "atual": _vm.pagination.atualPage,
      "total": _vm.pagination.totalPages
    },
    on: {
      "changePage": _vm.changePage
    }
  })], 1)])])])])])]), _vm._v(" "), (_vm.showRespostaLog) ? _c('popup-viewer', {
    on: {
      "close": _vm.closeRespostaLog
    }
  }, [_c('div', {
    staticClass: "wrapper-md",
    staticStyle: {
      "word-wrap": "break-word"
    }
  }, [_c('ul', [(_vm.logSelecionado.response.Guarda) ? _c('li', [_vm._v(_vm._s(_vm.logSelecionado.response.Guarda.Transacao) + " - GUARDA: " + _vm._s(_vm.logSelecionado.response.Guarda.Retorno))]) : _vm._e(), _vm._v(" "), (_vm.logSelecionado.response.Recolhimento) ? _c('li', [_vm._v(_vm._s(_vm.logSelecionado.response.Recolhimento.Transacao) + " - RECOLHIMENTO: " + _vm._s(_vm.logSelecionado.response.Recolhimento.Retorno))]) : _vm._e(), _vm._v(" "), (_vm.logSelecionado.response.dados) ? _c('li', [_vm._v("BOLETO: " + _vm._s(_vm.logSelecionado.response.dados.status.mensagem))]) : _vm._e(), _vm._v(" "), (_vm.logSelecionado.response.soapEnvelope) ? _c('li', [_vm._v("BOLETO: " + _vm._s(_vm.logSelecionado.response.soapEnvelope.soapBody[0].ConsultaBoletoPagoByNrBoletoResponse[0].ConsultaBoletoPagoByNrBoletoResult))]) : _vm._e(), _vm._v(" "), (_vm.logSelecionado.response[0]) ? _c('li', [_vm._v("RESPOSTA: " + _vm._s(_vm.logSelecionado.response))]) : _vm._e(), _vm._v(" "), (_vm.logSelecionado.response.grv) ? _c('li', [_vm._v(_vm._s(_vm.logSelecionado.response.grv.Guarda.Transacao) + " - GRV GUARDA: " + _vm._s(_vm.logSelecionado.response.grv.Guarda.Retorno))]) : _vm._e(), _vm._v(" "), (_vm.logSelecionado.response.grv) ? _c('li', [_vm._v(_vm._s(_vm.logSelecionado.response.grv.Recolhimento.Transacao) + " - GRV RECOLHIMENTO: " + _vm._s(_vm.logSelecionado.response.grv.Recolhimento.Retorno))]) : _vm._e(), _vm._v(" "), (_vm.logSelecionado.response.grve) ? _c('li', [_vm._v("GRVE: " + _vm._s(_vm.logSelecionado.response.grve))]) : _vm._e(), _vm._v(" "), (_vm.logSelecionado.response.Retorno) ? _c('li', [_vm._v(_vm._s(_vm.logSelecionado.response.Transacao) + " - RESPOSTA: " + _vm._s(_vm.logSelecionado.response.Retorno))]) : _vm._e()])])]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0419b394","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/logs/components/Logs.vue
// module id = 1647
// module chunks = 18